module.exports = __webpack_public_path__ + "static/media/icon_people.37655879.svg";